module.exports = __webpack_public_path__ + "static/media/stadium_5.b094d493.jpg";